import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=aab4d3e4&"
import script from "./Task.vue?vue&type=script&lang=js&"
export * from "./Task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aab4d3e4')) {
      api.createRecord('aab4d3e4', component.options)
    } else {
      api.reload('aab4d3e4', component.options)
    }
    module.hot.accept("./Task.vue?vue&type=template&id=aab4d3e4&", function () {
      api.rerender('aab4d3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Task.vue"
export default component.exports